import styled from 'styled-components';
export const getContextBadgeColors = (theme, variant) => {
    if (variant === 'application') {
        return {
            background: theme.colors.orange_4,
            border: theme.colors.orange_3,
            value: theme.colors.orange_1,
        };
    }
    if (variant === 'profile') {
        return {
            background: theme.colors.green_4,
            border: theme.colors.green_dark,
            value: theme.colors.green_dark,
        };
    }
    return {
        background: theme.colors.purple_5,
        border: theme.colors.purple_3,
        value: theme.colors.purple_1,
    };
};
export const ContextBadgeContainer = styled.div `
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm}px;
  padding: ${({ theme }) => `${theme.spacing.sm}px ${theme.spacing.md}px`};
  background: ${({ theme, $variant }) => getContextBadgeColors(theme, $variant).background};
  border-radius: ${({ theme }) => theme.border_radius.card};
  border: 1px solid
    ${({ theme, $variant }) => getContextBadgeColors(theme, $variant).border};
  width: fit-content;
  max-width: 100%;
`;
export const ContextBadgeContent = styled.div `
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm}px;
  min-width: 0;
`;
export const contextBadgeLinkStyle = {
    cursor: 'pointer',
    textDecoration: 'underline',
};
export const contextBadgeCloseStyle = {
    cursor: 'pointer',
};
